export default function WhoItsFor() {
  const users = [
    {
      icon: 'ri-user-heart-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Adult children',
      desc: 'Stay connected to elderly parents even when you do not live nearby. See updates, receive alerts, and coordinate care with siblings and caregivers.',
    },
    {
      icon: 'ri-heart-3-line',
      color: 'text-secondary-500',
      bg: 'bg-secondary-500/10',
      title: 'Elderly parents',
      desc: 'Get simple reminders and quick access to help. Large buttons, clear text, and a design that respects your independence while keeping family close.',
    },
    {
      icon: 'ri-hospital-line',
      color: 'text-accent-500',
      bg: 'bg-accent-500/10',
      title: 'Caregivers',
      desc: 'Record care tasks, notes, and updates in one place. Share observations with family members so everyone stays informed about daily wellbeing.',
    },
    {
      icon: 'ri-building-line',
      color: 'text-accent-400',
      bg: 'bg-accent-400/10',
      title: 'Care organizations',
      desc: 'Support better coordination between staff, families, and clients. Keep care records organized and communication transparent.',
    },
  ];

  return (
    <section id="who-it-is-for" className="bg-background-200 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            Created for families who want peace of mind
          </h2>
          <p className="text-base md:text-lg text-foreground-600/80 max-w-2xl mx-auto leading-relaxed">
            CareBridge is designed for everyone involved in caring for an elderly loved one. Whether you are across the street or across the country.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {users.map((user, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 border border-background-200/70 hover:shadow-md transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${user.bg} mb-5`}>
                <i className={`${user.icon} ${user.color} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors">
                {user.title}
              </h3>
              <p className="text-sm text-foreground-600/80 leading-relaxed">
                {user.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}